<template>
  <div
    class="card"
    @click="$router.push('/administration/device-management')"
    style="cursor: pointer"
  >
    <div class="card-body">
      <div class="d-flex align-items-center">
        <div class="avatar-xs me-3">
          <span
            class="
              avatar-title
              rounded-circle
              bg-soft bg-primary
              text-primary
              font-size-18
            "
          >
            <i class="mdi mdi-devices"></i>
          </span>
        </div>
        <h5 class="font-size-14 mb-0">
          {{ $t("menuitems.dashboards.list.systemHealthMonitor") }}
        </h5>
      </div>
      <div class="row" v-if="gisDevices.length > 0">
        <div class="col-sm-6 mt-4">
          <p class="text-center success">
            {{ $t("menuitems.dashboards.list.onlineDevices") }}
          </p>
          <h2 class="text-success text-center">{{ enabledCount }}</h2>
        </div>

        <div class="col-sm-6 mt-4">
          <p class="text-center">
            {{ $t("menuitems.dashboards.list.offlineDevices") }}
          </p>
          <h2 class="text-danger text-center">{{ disabledCount }}</h2>
        </div>
        <!-- <div class="col-sm-8">
          <apexchart
            class="apex-charts"
            type="radialBar"
            height="180"
            dir="ltr"
            :series="chartSeries"
            :options="chartOptions"
          ></apexchart>
        </div> -->
      </div>
      <div class="row text-center" v-else>
        <div class="col-12">
          <div class="m-3">Devices are not configured.</div>
        </div>

        <hr class="mt-5" />
        <div class="col-12">
          <router-link to="/administration/device-management">
            <button class="btn btn-sm btn-primary w-100">
              Configure Devices
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      chartOptions: {
        chart: {
          height: 180,
          type: "radialBar",
          offsetY: -10,
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            dataLabels: {
              name: {
                fontSize: "13px",
                color: undefined,
                offsetY: 60,
              },
              value: {
                offsetY: 22,
                fontSize: "16px",
                color: undefined,
                formatter: function (val) {
                  return val + "%";
                },
              },
            },
          },
        },
        colors: ["#6f42c1"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            shadeIntensity: 0.15,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 65, 91],
          },
        },
        stroke: {
          dashArray: 4,
        },
        labels: ["Online"],
      },
      series: [67],
    };
  },
  computed: {
    gisDevices() {
      return this.$store.getters["gis/devices"];
    },
    enabledCount() {
      return this.gisDevices.filter((e) => e.status == true).length;
    },
    disabledCount() {
      return this.gisDevices.filter((e) => e.status == false).length;
    },
    chartSeries() {
      return [Math.round((this.enabledCount / this.gisDevices.length) * 100)];
    },
  },
};
</script>